export default __webpack_public_path__ + "static/column-with-negative-values-3fbe43dc2cb5909af0dc6b8bfede8740.png";